import axios from "axios";
import {adap_pedido_pago} from "../Adaptadores/adap_pedido_pago";

export const iniciarPago = async (pedido) => {

    let pedido_procesado = adap_pedido_pago(pedido)



    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/2b5e5982-f7da-4144-9fb2-81e82f5e31a0', //test
        headers: {
            'Content-Type': 'application/json'
        },
        data: pedido_procesado
    };


    let dox = await axios.request(config)

    if (dox.status === 200) {
        return {
            res: true,
            data: dox.data.link
        }
    } else {
        return {
            res: false,
            data: dox.statusText
        }
    }


}